import Button from 'components/button';
import Header from 'components/header';
import { useNavigate } from 'react-router-dom';
import style from './style.module.scss';
import { useEffect, useRef } from 'react';
import * as Sentry from '@sentry/react';
import { ButtonFeedBackMemo } from './buttonFeedBack';

interface IFallbackComponent {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError(): void;
}

export function FallbackComponent({
  error,
  componentStack,
  eventId,
  resetError,
}: IFallbackComponent) {
  const navigator = useNavigate();

  const handleBack = () => {
    navigator('/');
    resetError();
  };

  return (
    <div className={style.container}>
      <Header text='Ошбика!' className={style.header} />

      <div className={style.text}>
        Произошла техническая ошибка, вкладка не доступна, просим вернться назад!
      </div>

      <div className={style.buttons}>
        <Button label='Назад' onClick={handleBack} />
        <ButtonFeedBackMemo />
      </div>
    </div>
  );
}
